import React, { useEffect } from 'react';
import {
  HashRouter as Router,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import './App.css';
import Navbar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import AboutPage from './pages/AboutPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import ThankYouPage from './pages/ThankYouPage';
import PlanningThankYouPage from './pages/PlanningThankYouPage';
import PartnerThankYouPage from './pages/PartnerThankYouPage';
import BrowseAllPage from './pages/BrowseAllPage';
import PartnerPage from './pages/PartnerPage';
import RequestBookingPage from './pages/RequestBookingPage';
import PlanningAssistancePage from './pages/PlanningAssistancePage';
import PartnerApplicationPage from './pages/PartnerApplicationPage';
import PersonalizedIdeasPage from './pages/PersonalizedIdeasPage';
import PackageRequestPage from "./pages/PackageRequestPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/business/:id" element={<ProductPage />} />
        <Route path="/about" element={<AboutPage />} />
  <Route path="/browse" element={<BrowseAllPage />} />
  <Route path="/partners" element={<PartnerPage />} />
        <Route  path="/termsAndConditions"  element={<TermsConditionsPage />} />
  <Route  path="/request-booking/:id" element={<RequestBookingPage />} />
<Route  path="/terms-conditions"  element={<TermsConditionsPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
  <Route path="/planning-thank-you" element={<PlanningThankYouPage />} />
  <Route path="/partner-thank-you" element={<PartnerThankYouPage />} />
    <Route path="/planning-assistance"  element={<PlanningAssistancePage />} />
    <Route path="/partner-application"  element={<PartnerApplicationPage />} />
  <Route  path="/personalized-ideas"  element={<PersonalizedIdeasPage />} />
  <Route path="/package-request" element={<PackageRequestPage />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
